import { CSSProperties, ReactChild, ReactNode } from 'react';

import './DialogContent.light.scss';
import './DialogContent.dark.scss';

interface Props {
  children: ReactChild | ReactNode;
  style?: CSSProperties;
}

export function DialogContent(props: Props) {
  return (
    <div
      className='dialog-content'
      style={{ ...(props.style || {}) }}>
      {props.children}
    </div>
  );
}
